
// import Navbar from '../../../components/customer/Navbar/MyNavbar'


import HeroSection from '../../../subscreens/customer/home/herosection/Herosection';
// import Servicesection from '../../../subscreens/customer/home/Homeservicesection/Servicesection';
// import Footer from '../../../components/customer/footer/Myfooter';
// import AboutUs from '../../../subscreens/customer/home/aboutus/AboutUs';
// import StatesSection from '../../../subscreens/customer/home/statessection/StatesSection';
import WhyChooseUs from '../../../subscreens/customer/home/whychooseus/WhyChooseUs';
import Navbar from '../../../components/customer/home/Navbar/MyNavbar';
// import Footer from '../../../components/customer/home/footer/Myfooter';
import Testimonial from '../../../subscreens/customer/home/testimonial/Testimonial';
// import Trustedservice from '../../../subscreens/customer/home/trustedservices/Trustedservice';
import HowItWorks from '../../../subscreens/customer/home/howitworks/HowItWorks';
import JoinAsWorker from '../../../subscreens/customer/home/worker section/JoinAsWorker';
import Topbar from '../../../components/customer/home/topbar/Topbar';
import Blogs from '../../../subscreens/customer/home/blogs/Blogs';
import TopServices from '../../../subscreens/customer/home/topservices/TopServices';
import Myfooter from '../../../components/customer/home/footer/Myfooter';
// import OurServices from '../../../subscreens/customer/dashboard/apphome/apphomeservicesection/AppHomeServicesection';
// import NearForYou from '../../../subscreens/customer/dashboard/apphome/nearforyou/NearForYou';
import ScrollToTop from '../../general/scrolltotop/ScrollToTop';



const Home = () => {

  return (
    <>
   <ScrollToTop />
      <Topbar />
      <Navbar />
      <HeroSection />
      {/* <Trustedservice /> */}
      {/* <Servicesection/> */}
      <TopServices/>
      {/* <NearForYou/> */}
      <JoinAsWorker />
      <WhyChooseUs />
      <Blogs />
        <HowItWorks />
      <Testimonial />
    
      <Myfooter />





    </>
  );
}
export default Home;
